// PROJECT and PROJECTS are workbench directories; PROJECT_FILES is a Nova project's directory
// and PROJECT_FILES_LIST lists them.
enum BaseDirectory {
  ORG = "organization",
  RAW = "raw",
  STANDARD = "standardized",
  ENRICHED = "enriched",
  STUDY_MANAGEMENT = "study_management",
  PROJECT = "workbench",
  PROJECT_FILES = "project",
  PROJECT_FILES_LIST = "projects",
  PROJECTS = "workbenches",
  PERSONAL = "personal",
  CURRENT_DATASET = "current-dataset",
}

export default BaseDirectory;
